import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _createClass from "@babel/runtime/helpers/createClass";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
/* eslint-disable prefer-spread */
import { EConstructionStatus } from '../../types/newbuilding-mvk';
import { sortByDates, sortByType } from '../array/sorters';
import { getHousesWithSections, getFlatTypeText } from '../map/polygon';
import { getFlatsInSectionFloor, getOffersConnectedToMVK } from './flats';
import { getFloorsInSection, getSectionViewModelsSortedByNames } from './sections';
export var QUARTER_MAP = {
  first: 1,
  fourth: 4,
  second: 2,
  third: 3
};
export var HouseUtils = /*#__PURE__*/_createClass(function HouseUtils(data) {
  var _this = this;
  _classCallCheck(this, HouseUtils);
  _defineProperty(this, "state", void 0);
  _defineProperty(this, "houses", []);
  _defineProperty(this, "sections", []);
  // Функция возвращает ViewModel корпусов
  _defineProperty(this, "getHouses", function () {
    if (!_this.houses.length) {
      var _this$state$houses = _this.state.houses,
        houses = _this$state$houses === void 0 ? [] : _this$state$houses;
      _this.houses = getHousesWithSections(houses).map(function (house) {
        var offersInSaleCount = house.sections.reduce(function (acc, section) {
          var floors = getFloorsInSection(_this.state, house.id, section.id);
          var offersCountByFloor = floors.reduce(function (floorAcc, floor) {
            return floorAcc + getFlatsInSectionFloor(_this.state, house.id, section.id, floor).length;
          }, 0);
          return acc + offersCountByFloor;
        }, 0);
        return {
          constructionStatus: house.constructionStatus,
          coordinates: house.polygon ? house.polygon.bbox.slice(0, 2) : undefined,
          deadlineData: _this.getDeadlineData(house),
          houseInfo: _this.getHouseInfo(house.id),
          id: house.id,
          name: house.name.replace(/ *\([^)]*\) */g, ''),
          offersInSaleCount: offersInSaleCount
        };
      });
    }
    return _this.houses;
  });
  // Получить текст со сроком сдачи корпуса
  _defineProperty(this, "getDeadlineData", function (house, section) {
    var constructionStatus = section ? section.constructionStatus : house.constructionStatus;
    if (constructionStatus === 'finished') {
      return {
        text: house.sections.length > 1 ? 'Сдана' : 'Сдан'
      };
    }
    var offers = _this.getOffersByHouse(house.id, section ? section.number : undefined);

    // Берем с максимальным годом
    var year = Number(Math.max.apply(Math, offers.map(function (offer) {
      return offer.deadlineYear;
    })));
    var offersWithMaxYear = offers.filter(function (offer) {
      return offer.deadlineYear === year;
    });

    // Берем с максимальным кварталом
    var quarter = Number(Math.max.apply(Math, offersWithMaxYear.map(function (offer) {
      return QUARTER_MAP[offer.deadlineQuarter || -1];
    })));

    // Есть ли в корпусе сданные офферы
    var hasCompletedOffers = offers.some(function (offer) {
      return !!offer.isComplete;
    });
    var hasCompletedOffersText = hasCompletedOffers ? ', сданные' : '';
    if (isFinite(year) && isFinite(quarter)) {
      return {
        quarter: quarter,
        text: "".concat(quarter, " \u043A\u0432. ").concat(year).concat(hasCompletedOffersText),
        year: year
      };
    }
    return {
      text: "\u0421\u0442\u0440\u043E\u0438\u0442\u0441\u044F".concat(hasCompletedOffersText)
    };
  });
  // Возвращает квартиры, относящиеся к корпусу и секции
  _defineProperty(this, "getOffersByHouse", function (houseId, sectionNumber) {
    // Получаем квартиры, которые привязаны к МВК, итерируя по секциям и этажам
    var offers = getOffersConnectedToMVK(_this.state, houseId);
    return sectionNumber === undefined ? offers : offers.filter(function (offer) {
      return offer.sectionNumber === sectionNumber;
    });
  });
  // Возвращает статистику по корпусу: название, дата сдачи, кол-во квартир, минимумы по площадям и ценам
  _defineProperty(this, "getHouseInfo", function (houseId, sectionNumber) {
    var house = _this.state.houses.find(function (item) {
      return item.id === houseId;
    });
    if (!house) {
      return [];
    }
    var offers = _this.getOffersByHouse(houseId, sectionNumber).filter(function (offer) {
      return house.sections.some(function (section) {
        return section.number === offer.sectionNumber;
      });
    });
    if (!offers.length) {
      return [];
    }
    var maxRoomCount = Math.max.apply(Math, offers.map(function (offer) {
      return offer.roomCount;
    }));
    var result = [];
    var _loop = function _loop(i) {
      var offersByRoom = offers.filter(function (offer) {
        return offer.roomCount === i;
      });
      var item = _objectSpread({
        roomCount: i
      }, _this.getOfferInfoByRoomCount(offersByRoom));
      if (isFinite(item.minArea) && isFinite(item.minPrice)) {
        result.push(item);
      }
    };
    for (var i = 0; i <= maxRoomCount; i++) {
      _loop(i);
    }
    return result.sort(function (_, nextItem) {
      return nextItem.roomCount === 9 ? 1 : 0;
    });
  });
  _defineProperty(this, "getOfferInfoByRoomCount", function (offers) {
    return {
      minArea: Number(Math.min.apply(Math, offers.map(function (offer) {
        return offer.area;
      }))),
      minPrice: Number(Math.min.apply(Math, offers.map(function (offer) {
        return offer.price;
      })))
    };
  });
  // Функция возвращает ViewModel секций
  _defineProperty(this, "getSections", function (houseId) {
    var selectedHouse = _this.state.houses.find(function (house) {
      return house.id === houseId;
    });
    if (!selectedHouse) {
      return _this.sections;
    }
    if (!_this.sections.some(function (section) {
      return section.house.id === houseId;
    })) {
      var sectionsByHouse = selectedHouse.sections.map(function (section) {
        var modernSection = _objectSpread(_objectSpread({}, section), {}, {
          constructionStatus: _this.getConstructionStatusForSection(section, selectedHouse)
        });
        var floors = getFloorsInSection(_this.state, selectedHouse.id, section.id);
        var sectionFlats = floors.reduce(function (acc, floor) {
          return acc.concat(getFlatsInSectionFloor(_this.state, selectedHouse.id, section.id, floor));
        }, []);
        var houseInfo = _this.getHouseInfo(selectedHouse.id, section.number);
        if (!houseInfo.length) {
          return undefined;
        }
        return {
          constructionStatus: modernSection.constructionStatus,
          deadlineData: _this.getDeadlineData(selectedHouse, modernSection),
          house: selectedHouse,
          houseInfo: houseInfo,
          id: section.id,
          offersInSaleCount: sectionFlats.length,
          sectionData: section,
          flatTypeText: getFlatTypeText(sectionFlats)
        };
      }).filter(Boolean);
      _this.sections = getSectionViewModelsSortedByNames([].concat(_toConsumableArray(_this.sections), _toConsumableArray(sectionsByHouse)).sort(sortByType).sort(sortByDates));
    }
    return _this.sections.filter(function (section) {
      return section.house.id === houseId;
    });
  });
  _defineProperty(this, "getConstructionStatusForSection", function (section, house) {
    var offers = _this.getOffersByHouse(house.id, section.number);
    return offers.length && offers.every(function (offer) {
      return !!offer.isComplete;
    }) ? EConstructionStatus.Finished : house.constructionStatus;
  });
  this.state = data;
  // Инициализация всех секций в this.sections
  var _houses = this.getHouses();
  _houses.forEach(function (house) {
    if (house.houseInfo.length) {
      _this.getSections(house.id);
    }
  });
});
_defineProperty(HouseUtils, "instance", void 0);
_defineProperty(HouseUtils, "getInstance", function (data) {
  var isDataTheSame = HouseUtils.instance && HouseUtils.instance.state === data;
  HouseUtils.instance = isDataTheSame && HouseUtils.instance || new HouseUtils(data);
  return HouseUtils.instance;
});